import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
	const splideElement = document.querySelector(
		'.splide[aria-label="Logo Carousel Row 1"]'
	);
	if (!splideElement) return;

	const logoHeight = splideElement.getAttribute('data-logo-height');

	let splideOptions = {
		type: "loop",
		drag: false,
		focus: "center",
		perPage: 12,
		pagination: false,
		arrows: false,
		autoWidth: logoHeight === 'tall',
		breakpoints: {
			1280: {
				perPage: 12,
			},
			768: {
				perPage: 6,
			},
			640: {
				perPage: 6,
			},
		},
		autoScroll: false,
	};

	const autoScroll = splideElement.dataset.autoScroll;
	if (autoScroll !== "false") {
		splideOptions.autoScroll = {
			speed: 1,
			pauseOnHover: false,
		};
	}

	new Splide('.splide[aria-label="Logo Carousel Row 1"]', splideOptions).mount({
		AutoScroll,
	});

	const row2 = document.querySelector(
		'.splide[aria-label="Logo Carousel Row 2"]'
	);
	if (row2) {
		if (autoScroll !== "false") {
			splideOptions.autoScroll = {
				speed: -1,
				pauseOnHover: false,
			};
		}
		new Splide(row2, splideOptions).mount({ AutoScroll });
	}
});
